export default {
    groups: [
        {
            id: 1,
            label: 'Основные реквизиты',
            collapsed: false,
        },
        {
            id: 2,
            label: 'Общероссийские классификаторы',
            collapsed: false,
        },
        {
            id: 3,
            label: 'Адреса',
            collapsed: false,
        },
        {
            id: 4,
            label: 'Статус',
            collapsed: false,
        },
        {
            id: 5,
            label: 'ЕГРЮЛ/ЕГРИП',
            collapsed: false,
        },
    ],
    components: [
        // GROUP 1
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Код',
            groupId: 1,
            size: [1, 2],
            fieldNameText: 'nump',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Наименование',
            groupId: 1,
            size: [1, 4],
            fieldNameText: 'name',
            validationRules: {
                required: true,
            },
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Полное наименование',
            groupId: 1,
            size: [1, 6],
            fieldNameText: 'allname',
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'ИНН',
            groupId: 1,
            size: [1, 2],
            fieldNameText: 'inn',
        },
        {
            fieldNameText: 'kpp',
            title: 'КПП',
            fieldType: 'ai-form-text-box-readonly',
            groupId: 1,
            size: [1, 1],
        },
        {
            fieldNameText: 'pr_rezident_rf',
            title: 'Резидент РФ',
            fieldType: 'ai-form-check-box-readonly',
            groupId: 1,
            size: [1, 1],
            validationRules: {
                required: true,
            },
        },
        {
            fieldNameText: 'es_id',
            title: 'Ид. внеш. системы',
            fieldType: 'ai-form-text-box-readonly',
            groupId: 1,
            size: [1, 2],
        },
        {
            fieldNameText: 'parent_name',
            title: 'Головное предприятие',
            fieldType: 'ai-form-text-box-readonly',
            groupId: 1,
            size: [1, 5],
        },
        {
            fieldNameText: 'parent_inn',
            title: 'ИНН головного предприятия',
            fieldType: 'ai-form-text-box-readonly',
            groupId: 1,
            size: [1, 2],
        },
        {
            fieldNameText: 'parent_kpp',
            title: 'КПП головного предприятия',
            fieldType: 'ai-form-text-box-readonly',
            groupId: 1,
            size: [1, 2],
        },

        // // GROUP 2
        {
            fieldNameText: 'ministry_name',
            title: 'Министерство',
            fieldType: 'ai-form-text-box-readonly',
            groupId: 2,
            size: [1, 6],
        },
        {
            fieldNameText: 'okpo',
            title: 'ОКПО',
            fieldType: 'ai-form-text-box-readonly',
            groupId: 2,
            size: [1, 3],
        },
        {
            fieldNameText: 'ogrn',
            title: 'ОГРН',
            fieldType: 'ai-form-text-box-readonly',
            groupId: 2,
            size: [1, 3],
        },
        {
            fieldNameText: 'okugo',
            title: 'ОКУГО',
            fieldType: 'ai-form-text-box-readonly',
            groupId: 2,
            size: [1, 3],
        },
        {
            fieldNameText: 'okato',
            title: 'ОКАТО',
            fieldType: 'ai-form-text-box-readonly',
            groupId: 2,
            size: [1, 3],
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'ОКОПФ',
            fieldNameText: 'okfs',
            groupId: 2,
            size: [1, 6],
        },
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'ОКВЭД',
            fieldNameText: ['okved', 'name'],
            groupId: 2,
            size: [1, 6],
        },

        // // // GROUP 3
        {
            fieldNameText: 'adr_ur',
            title: 'Юридический адрес',
            fieldType: 'ai-form-text-box-readonly',
            groupId: 3,
            size: [1, 6],
        },
        {
            fieldNameText: 'adres_pd',
            title: 'В платежных документах',
            fieldType: 'ai-form-text-box-readonly',
            groupId: 3,
            size: [1, 3],
        },
        {
            name: 'component-pd-addr-fmt',
            fieldNameId: 'pd_addr_fmt',
            fieldNameText: 'pd_addr_fmt_txt',
            groupId: 3,
            size: [1, 1],
            extParams: {
                valueExpr: 'kod',
                displayExpr: 'name',
            },
        },
        {
            name: 'component-egr-view-button-new',
            groupId: 3,
            size: [1, 2],
        },
        {
            fieldNameText: 'adr_fiz',
            title: 'Адрес местонахождения',
            fieldType: 'ai-form-text-box-readonly',
            groupId: 3,
            size: [1, 6],
        },
        {
            fieldNameText: 'adr_p',
            title: 'Адрес для переписки',
            fieldType: 'ai-form-text-box-readonly',
            groupId: 3,
            size: [1, 6],
        },

        // // // GROUP 4
        {
            title: 'Дата архивации',
            fieldType: 'ai-form-date-box-readonly',
            fieldNameText: 'dat_udal',
            groupId: 4,
            size: [1, 3],
        },
        {
            title: 'Отношение к энергосистеме',
            fieldType: 'ai-form-text-box-readonly',
            fieldNameText: 'ecls_name',
            groupId: 4,
            size: [1, 3],
        },
        {
            fieldNameText: 'name_busin',
            title: 'Основание для прекращения деятельности',
            fieldType: 'ai-form-text-box-readonly',
            groupId: 4,
            size: [1, 3],
        },

        // // GROUP 5
        {
            fieldNameText: 'pr_ogrn',
            fieldType: 'ai-form-check-box-readonly',
            title: 'Связан с ЕГРН',
            groupId: 5,
            size: [1, 1],
        },
        {
            fieldNameText: 'egrul_cert_num',
            title: 'Свидетельство о регистрации',
            fieldType: 'ai-form-text-box-readonly',
            groupId: 5,
            size: [1, 3],
        },
        {
            title: 'Дата выдачи свидетельства',
            fieldType: 'ai-form-date-box-readonly',
            fieldNameText: 'egrul_cert_date',
            groupId: 5,
            size: [1, 2],
        },
        {
            fieldNameText: 'egrul_organ',
            title: 'Наимен. органа, выдавшего свидетельство',
            fieldType: 'ai-form-text-box-readonly',
            groupId: 5,
            size: [1, 6],
        },
        {
            fieldNameText: 'ac_egr_status_name',
            title: 'Статус по справочнику СЮЛСТ/СИПСТ',
            fieldType: 'ai-form-text-box-readonly',
            groupId: 5,
            size: [1, 4],
        },
        {
            title: 'Дата решения о предст. исключ. из ЕГРЮЛ',
            fieldType: 'ai-form-date-box-readonly',
            fieldNameText: 'ac_egr_exclude_decision_date',
            groupId: 5,
            size: [1, 2],
        },
        {
            fieldNameText: 'ac_egr_sulpd_name',
            title: 'Способ прекращ. по справочнику СЮЛПД',
            fieldType: 'ai-form-text-box-readonly',
            groupId: 5,
            size: [1, 4],
        },
        {
            title: 'Дата прекращения',
            fieldType: 'ai-form-date-box-readonly',
            fieldNameText: 'ac_egr_termination_date',
            groupId: 5,
            size: [1, 2],
        },
    ],
};
